import createReducer from "./createReducer";
import { SUPPRESS_ALL_GROWL, filterAdvertiserObjectivesForTargetMethod } from "utils/constants";
import { CREATIVE_TAXONOMY_ACTIONS } from "reducers/actions/Creatives";
import { CREATIVE_VERSIONS_ACTIONS } from "reducers/actions/CreativeVersions";

export const ADVERTISER_DETAILS_ACTIONS = {
	LOAD_ADVERTISER_DETAILS_AJAX: "LOAD_ADVERTISER_DETAILS_AJAX",
	LOAD_ADVERTISER_DETAILS_SUCCESS: "LOAD_ADVERTISER_DETAILS_SUCCESS",
	LOAD_ADVERTISER_DETAILS_ERROR: "LOAD_ADVERTISER_DETAILS_ERROR",

	LOAD_ADVERTISER_OBJECTIVES_AJAX: "LOAD_ADVERTISER_OBJECTIVES_AJAX",
	LOAD_ADVERTISER_OBJECTIVES_SUCCESS: "LOAD_ADVERTISER_OBJECTIVES_SUCCESS",
	LOAD_ADVERTISER_OBJECTIVES_ERROR: "LOAD_ADVERTISER_OBJECTIVES_ERROR",

	CLEAR_ADVERTISER_DETAILS: "CLEAR_ADVERTISER_DETAILS",
};

const initialState = {
	isLoaded: true,
	error: null,
	data: {},
	objectives:{},
};

export function loadAdvertiserDetails(libraryId) {
	return (dispatch) => {
		return dispatch({
			type: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_AJAX,
			meta: SUPPRESS_ALL_GROWL,
			AJAX: {
				gateway: "crm",
				url: `ui/creative-libraries/${libraryId}/advertiser`,
				success: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_SUCCESS,
				error: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_ERROR,
			},
		});
	};
}

export function loadAdvertiserObjectives(id){
	return (dispatch) => {
		return dispatch({
			type: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_OBJECTIVES_AJAX,
			meta: SUPPRESS_ALL_GROWL,
			AJAX: {
				gateway: "adm",
				url: `ui/advertisers/${id}/objectives`,
				params: { rpp: 50 },
				success: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_OBJECTIVES_SUCCESS,
				error: ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_OBJECTIVES_ERROR,
			},
		});
	};
}

export function resetDetails() {
	return (dispatch) => {
		return dispatch({
			type: ADVERTISER_DETAILS_ACTIONS.CLEAR_ADVERTISER_DETAILS,
		});
	};
}


const handlers = {
	[ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_AJAX]: isLoadingAdvertiserDetails,
	[ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_SUCCESS]: initAdvertiserDetails,
	[ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_DETAILS_ERROR]: loadAdvertiserDetailsError,

	[ADVERTISER_DETAILS_ACTIONS.LOAD_ADVERTISER_OBJECTIVES_SUCCESS]:initAdvertiserObjectives,

	[ADVERTISER_DETAILS_ACTIONS.CLEAR_ADVERTISER_DETAILS]: clearDetails,

	[CREATIVE_TAXONOMY_ACTIONS.CLASSIFY_CREATIVES_SUCCESS]: updateTaxonomyCredits,
	[CREATIVE_VERSIONS_ACTIONS.CLASSIFY_VERSIONS_SUCCESS]: updateTaxonomyCredits,
};

const actionCreators = {
	isLoadingAdvertiserDetails,
	loadAdvertiserDetails,
	loadAdvertiserDetailsError,
	resetDetails,
};

const reducerConfig = {
	typeRoot: "ADVERTISER_DETAILS_ACTIONS",
	initialState,
	actionTypes: ADVERTISER_DETAILS_ACTIONS,
	actionCreators,
	handlers,
};

function isLoadingAdvertiserDetails(state, action) {
	return {
		...state,
		data: {},
		isLoaded: false,
	};
}

function initAdvertiserDetails(state, action) {
	const { data } = action.payload;

	return {
		...state,
		data,
		isLoaded: true,
		error: null,
	};
}

function loadAdvertiserDetailsError(state, action) {
	const { message }  = action.payload.error;

	return {
		...state,
		data: {},
		error: message,
		isLoaded: true,
	};
}

function initAdvertiserObjectives(state, action){
	return {
		...state,
		objectives:{
			...action.payload.data,
			items:action.payload.data.items.map((v) => {
				return {
					...v,
					value:v.id,
					label:v.name,
				};
			}),
		},
	};
}

function clearDetails(state, action) {
	return { ...initialState };
}

export function updateTaxonomyCredits(state, action){
	// If there's a problem with the response's remainingCredits, just use the value we have already.
	const remainingCredits = action?.payload?.data?.remainingCredits ?? state.data?.creativeTaxonomy?.remainingCredits;
	return {
		...state,
		data: {
			...state.data,
			creativeTaxonomy: {
				...state.data?.creativeTaxonomy,
				remainingCredits,
			},
		},
	};
}

export const selectActiveAdvertiserObjectives = (state, targetMethod) => {
	const objs = state.advertiserDetails.objectives?.items || [];
	return filterAdvertiserObjectivesForTargetMethod(objs, targetMethod)
		.filter(obj => obj?.status === "Active")
		.map(({ id, name }) => {
			return {
				value: { id, name },
				label: `${name} (${id})`,
			};
		});
};

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const AdvertiserDetails = reducerConfig.actionCreators;
